import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const DeliveriesPage = lazy(() => import('./DeliveriesPage'));
const BroadcastsPage = lazy(() => import('./BroadcastsPage'));
const BroadcastComposerPage = lazy(() => import('./BroadcastComposerPage'));
const BroadcastDetailPage = lazy(() => import('./BroadcastDetailPage'));
const DevicesPage = lazy(() => import('./DevicesPage'));

export const notificationRoutes: RouteObject[] = [
  {
    path: 'notifications',
    element: (
      <ProtectedRoute action="notifications:view">
        <DeliveriesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'notifications/broadcasts',
    element: (
      <ProtectedRoute action="notifications:view">
        <BroadcastsPage />
      </ProtectedRoute>
    ),
  },
  // Static `new` is declared before `:id` so it is never read as a broadcast id.
  {
    path: 'notifications/broadcasts/new',
    element: (
      <ProtectedRoute action="notifications:broadcast">
        <BroadcastComposerPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'notifications/broadcasts/:id',
    element: (
      <ProtectedRoute action="notifications:view">
        <BroadcastDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'notifications/devices',
    element: (
      <ProtectedRoute action="notifications:view">
        <DevicesPage />
      </ProtectedRoute>
    ),
  },
];
